import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getSessionId = () => {
  let sid = localStorage.getItem("orelie_session");
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("orelie_session", sid);
  }
  return sid;
};

export const api = {
  getProducts: (category) => client.get("/products", { params: category ? { category } : {} }).then((r) => r.data),
  getProduct: (id) => client.get(`/products/${id}`).then((r) => r.data),
  getCart: (sid) => client.get(`/cart/${sid}`).then((r) => r.data),
  addToCart: (sid, product_id, quantity = 1) => client.post(`/cart/${sid}/add`, { product_id, quantity }).then((r) => r.data),
  updateCartItem: (sid, product_id, quantity) => client.put(`/cart/${sid}/item`, { product_id, quantity }).then((r) => r.data),
  removeCartItem: (sid, product_id) => client.delete(`/cart/${sid}/item/${product_id}`).then((r) => r.data),
  getWishlist: (sid) => client.get(`/wishlist/${sid}`).then((r) => r.data),
  toggleWishlist: (sid, product_id) => client.post(`/wishlist/${sid}/toggle`, { product_id }).then((r) => r.data),
  newsletter: (email) => client.post("/newsletter", { email }).then((r) => r.data),
  contact: (payload) => client.post("/contact", payload).then((r) => r.data),
  checkout: (payload) => client.post("/checkout", payload).then((r) => r.data),
  createStripeCheckout: (payload) => client.post("/payments/checkout", payload).then((r) => r.data),
  paymentStatus: (session_id) => client.get(`/payments/status/${session_id}`).then((r) => r.data),
};

export const formatPrice = (v) =>
  new Intl.NumberFormat("ro-RO", { style: "currency", currency: "RON", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
